


import * as React from 'react';

import { Link, useHistory } from 'react-router-dom'

const CustomNavLink: React.FunctionComponent<{
    children: React.ReactNode
    to?: string
    onClick?(e: any): void
    className?: string
    style?: React.CSSProperties
}> = (props): JSX.Element => {
    let history = useHistory()
    // Conditionally wrapping content into a link
    const ContentTag = props.to ? Link : 'div';


    const naviagte = (path: string): void => {
        history.push({
            pathname: `${path}`
        });
    }

    const handleClick = (e) => {
        e.preventDefault()

        if (props.onClick) {
            props.onClick(e)
        }
        if (props.to != null && props.to != "") {
            naviagte(props.to)
        }
    }

    return (
        <ContentTag
            // @ts-ignore
            to={props.to}
            // @ts-ignore
            onClick={handleClick} className={props.className} style={props.style}>{props.children}</ContentTag>
    );
}

export default CustomNavLink
export { CustomNavLink }